const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const buttonAdd = document.querySelectorAll('.button-add');

if (buttonAdd) {
    if (viewportWidth < 992) {
        buttonAdd.forEach(button => {
            button.textContent = 'koop';
        })
    }
}

$( document ).ready(function() {
  
  function shotsText() {
    var productOption = $('.single-option-selector[data-index="option2"] option:selected').val();
    var productOptionEnd = productOption.replace('ml','');
    var productOptionValue = Math.floor(productOptionEnd / 20);
    console.log(productOptionEnd);
    $('.label-shots .shots').text(productOptionValue);

    if(productOptionEnd == 30) {
      $('.label-shots').hide();
    } else {
      $('.label-shots').show();
    }
  }
  
  shotsText();

  jQuery('.single-option-selector').on('change', function() {
    shotsText();
  }); 
  

  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
  
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
  
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }
  waitForElm('.rc_container').then((elm) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const variant = urlParams.get('variant');


    let rechargeForm = document.querySelector('.rc_container');
    var rID = variant;

    if (rID == "46724894753117" || rID == "46732948406621" || rID == "46812373221725" || rID == "46812373188957" || rID == "46812373188957" || rID == "46812712534365" || rID == "46812712501597" || rID == "46812712599901" || rID == "46812712632669") {
      rechargeForm.style.display = 'none'
      document.querySelector('.rc_widget__option--onetime input').click();
    } else {
      rechargeForm.style.display = 'block'
    }
  });
  
});

document.addEventListener('DOMContentLoaded', function() {
  var contactForm = document.getElementById('contact_form');
  var thankYouMessage = document.getElementById('thank-you-message');
  
  if (contactForm) {
    contactForm.addEventListener('submit', function(event) {
      event.preventDefault();
      console.log('Form submitted'); // Debug log

      // Create a FormData object from the form
      var formData = new FormData(contactForm);
      
      // Use fetch API to submit the form
      fetch(contactForm.action, {
        method: 'POST',
        body: new URLSearchParams(formData)
      })
      .then(response => {
        console.log('Fetch response received'); // Debug log
        if (response.ok) {
          console.log('Form submission successful'); // Debug log
          // Hide the form and show the thank you message
          contactForm.style.display = 'none';
          thankYouMessage.style.display = 'block';
        } else {
          console.error('Form submission error', response); // Debug log
          // Handle error
          alert('Er is iets misgegaan bij het verzenden van uw aanvraag. Probeer het opnieuw.');
        }
      })
      .catch(error => {
        console.error('Fetch error', error); // Debug log
        // Handle error
        alert('Er is iets misgegaan bij het verzenden van uw aanvraag. Probeer het opnieuw.');
      });
    });
  }
});
